<section class="no-padding">
	<section class="padding-bottom-20" *ngIf="asOfDate"><span dcrHTMLKey="FAMILY_AS_OF">As of</span> {{ asOfDate }}</section>
	<mb-commentary-text *componentId="[{ componentId: 'me.family.commentary', ids: familyIds }]; let res" [data]="res"></mb-commentary-text>
	<ac-disclosure [isExpandable]="false"><span dcrHTMLKey="COMMENTARY_DISCLOSURE">COMMENTARY_DISCLOSURE</span></ac-disclosure>
	<ng-container *ngIf="marketViewConfig$ | async as marketViewConfig">
		<mv-market-views [defaultTranslationFromConfig]="marketViewConfig" [showHeader]="false" [asOfDate]="asOfDate"></mv-market-views>
	</ng-container>
</section>
